import { useGetList } from 'react-admin';
import { TaskTemplateRecord } from './types';

export const useTaskTemplates = () => {

  const { data, isLoading, error } = useGetList<TaskTemplateRecord>('task-templates', {
    pagination: { page: 1, perPage: 100 },
    sort: { field: 'templateName', order: 'ASC' },
  });

  const taskTemplates = data || [];

  const getTaskTemplateById = (id: string | null | undefined): TaskTemplateRecord | null => {

    if (!id) return null;
    return taskTemplates.find((template) => template.id === id) || null;

  };

  return {
    taskTemplates,
    isLoading,
    error,
    getTaskTemplateById,
  };

};
